"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTabsControlled = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var react_1 = require("react");
var globalHandlers_1 = __importDefault(require("../handlers/globalHandlers"));
var ACTabsControlled = function (props) {
    var _a = props.options, options = _a === void 0 ? [] : _a, context = props.context, propValue = props.value, showSerialNumbers = props.showSerialNumbers;
    if (!Array.isArray(options) || (options === null || options === void 0 ? void 0 : options.length) === 0)
        return;
    var visibleOptions = (0, react_1.useMemo)(function () {
        if (!Array.isArray(options))
            return [];
        return options
            .filter(function (e) {
            return (e === null || e === void 0 ? void 0 : e.visibleCondition)
                ? globalHandlers_1.default.execFunction({ condition: e.visibleCondition }, context)
                : true;
        })
            .map(function (op) { return (__assign(__assign({}, op), { key: (op === null || op === void 0 ? void 0 : op[(props === null || props === void 0 ? void 0 : props.optionValueKey) || '']) || (op === null || op === void 0 ? void 0 : op.key) || (op === null || op === void 0 ? void 0 : op.value), label: (op === null || op === void 0 ? void 0 : op[(props === null || props === void 0 ? void 0 : props.optionLabelKey) || '']) || (op === null || op === void 0 ? void 0 : op.label) })); });
    }, [options, context]);
    var _b = (0, react_1.useState)(propValue), value = _b[0], setValue = _b[1];
    (0, react_1.useEffect)(function () {
        var _a;
        var firstOptionKey = visibleOptions.length ? (_a = visibleOptions[0]) === null || _a === void 0 ? void 0 : _a.key : '';
        setValue(propValue || firstOptionKey);
        if (!propValue) {
            handleChange(firstOptionKey);
        }
    }, [propValue, visibleOptions]);
    var handleChange = function (key) {
        if (props.onChange) {
            props.onChange(key);
        }
    };
    return ((0, jsx_runtime_1.jsx)(antd_1.Tabs, { tabPosition: (props === null || props === void 0 ? void 0 : props.tabPosition) || 'top', defaultActiveKey: value, activeKey: value, size: "small", className: "outline-none ring-0 ".concat(props.containerClassName, " ").concat((props === null || props === void 0 ? void 0 : props.variant) || 'default'), items: visibleOptions.map(function (option, index) { return ({
            key: option.key || '',
            label: ((0, jsx_runtime_1.jsxs)("span", { className: "flex items-center gap-1 ".concat(props.className), children: [((option === null || option === void 0 ? void 0 : option.icon) || (option === null || option === void 0 ? void 0 : option.iconClassName)) && ((0, jsx_runtime_1.jsx)("i", { className: "aci ".concat((option === null || option === void 0 ? void 0 : option.icon) || (option === null || option === void 0 ? void 0 : option.iconClassName), " ").concat((props === null || props === void 0 ? void 0 : props.optionIconClassName) || '') })), showSerialNumbers && "".concat(index + 1, "."), option === null || option === void 0 ? void 0 : option.label] })),
        }); }), onChange: handleChange }, props === null || props === void 0 ? void 0 : props.name));
};
exports.ACTabsControlled = ACTabsControlled;
